import React, { useState } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import LocationSelector from "../Common/LocationSelector";

const PublicMobileHeader = ({ currentLocation, setCurrentLocation }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <>
      <div className="md:hidden bg-white px-4 flex justify-between items-center">
        <div
          className="flex items-center cursor-pointer"
          onClick={() => navigate("/home")}
        >
          <img src="/upswap.png" alt="UpSwap Logo" className="h-10 w-24" />
        </div>
        <LocationSelector
          initialLocation={currentLocation}
          onLocationSelected={(newLocation) => {
            setCurrentLocation(newLocation);
            localStorage.setItem("userLocation", JSON.stringify(newLocation));
          }}
          displayClassName="ml-4"
        />

        {/* Right: Menu Icon */}
        <button
          onClick={() => setMenuOpen(true)}
          className="text-gray-700 text-xl"
        >
          <FaBars />
        </button>
      </div>

      {/* Mobile Side Menu - Slide in from right */}
      {menuOpen && (
        <div className="fixed inset-0 z-50 flex">
          {/* Background overlay */}
          <div
            className="flex-1 bg-black bg-opacity-40"
            onClick={() => setMenuOpen(false)}
          ></div>

          {/* Right side menu */}
          <div className="w-64 bg-white p-8 h-full fixed right-0 top-0 rounded-l-lg transition-transform transform translate-x-0">
            <div className="flex justify-between items-center mb-6">
              <img src="/upswap.png" className="h-8" alt="logo" />
              <button
                onClick={() => setMenuOpen(false)}
                className="text-gray-600"
              >
                <FaTimes size={20} />
              </button>
            </div>

            {/* Navigation Links */}
            <div className="space-y-4">
              <button
                onClick={() => {
                  navigate("/LocalActivities");
                  setMenuOpen(false);
                }}
                className="block w-full text-left text-gray-700 font-medium hover:text-orange-500"
              >
                Browse Activities
              </button>
              <button
                onClick={() => {
                  navigate("/PopularDeals");
                  setMenuOpen(false);
                }}
                className="block w-full text-left text-gray-700 font-medium hover:text-orange-500"
              >
                Browse Deals
              </button>
              <button
                onClick={() => {
                  navigate("/vendor");
                  setMenuOpen(false);
                }}
                className="block w-full text-left text-gray-700 font-medium hover:text-orange-500"
              >
                Browse Vendors
              </button>
              <hr className="my-2" />
              <button
                onClick={() => {
                  navigate("/createAccount");
                  setMenuOpen(false);
                }}
                className="w-full bg-orange-500 text-white px-4 py-2 rounded-md hover:bg-orange-600"
              >
                Sign Up
              </button>
              <button
                onClick={() => {
                  navigate("/login");
                  setMenuOpen(false);
                }}
                className="w-full border border-gray-300 text-gray-700 px-4 py-2 rounded-md hover:bg-gray-100"
              >
                Login
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PublicMobileHeader;
